const data={
    "productData": [
    {
        "cat_name": "groceries",
        "id": "1",
        "image": "https://cdn-icons-png.flaticon.com/512/3724/3724788.png",
        "items": [
            {
                "cat_name": "dals and pulses",
                "products": [
                    {
                        "productName": "Good Life Whole Moong 500 g",
                        "price": "20",
                        "oldPrice": "140",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491187309/good-life-whole-moong-500-g-product-images-o491187309-p491187309-0-202308311426.jpg",
                        "discount": "12",
                        "brand": "AASHIRVAAD",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491187309/good-life-whole-moong-500-g-product-images-o491187309-p491187309-0-202308311426.jpg",
                            "https://www.jiomart.com/images/product/original/491187309/good-life-whole-moong-500-g-product-images-o491187309-p491187309-1-202308311426.jpg",
                            "https://www.jiomart.com/images/product/original/491187309/good-life-whole-moong-500-g-product-images-o491187309-p491187309-2-202308311426.jpg",
                            "https://www.jiomart.com/images/product/original/491187309/good-life-whole-moong-500-g-product-images-o491187309-p491187309-3-202308311426.jpg",
                            "https://www.jiomart.com/images/product/original/491187309/good-life-whole-moong-500-g-product-images-o491187309-p491187309-4-202308311426.jpg",
                            "https://www.jiomart.com/images/product/original/491187309/good-life-whole-moong-500-g-legal-images-o491187309-p491187309-5-202308311427.jpg"
                        ],
                        "rating": 3.5,
                        "description": "Good Life Whole Moong is one of the light meal to digest. It is often given to people who prefer diet for fitness. It contains antioxidants which are very healthy for the good functioning of the human body. It can be included in our daily diet as it can fulfil the nutritional and dietary requirements of an entire meal. Buy Good Life Whole Moong online now!",
                        "id": 1
                    },
                    {
                        "productName": "Moong Dal 2 kg",
                        "price": "246",
                        "oldPrice": "320",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491432711/moong-dal-2-kg-product-images-o491432711-p491432711-0-202205191636.jpg",
                        "discount": "16",
                        "brand": "Private Label",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491432711/moong-dal-2-kg-product-images-o491432711-p491432711-0-202205191636.jpg",
                            "https://www.jiomart.com/images/product/original/491432711/moong-dal-2-kg-product-images-o491432711-p491432711-1-202205191636.jpg",
                            "https://www.jiomart.com/images/product/original/491432711/moong-dal-2-kg-legal-images-o491432711-p491432711-3-202205191636.jpg"
                        ],
                        "rating": 4,
                        "description": "Moong Dal is essentially packed with loads of nutrients that are extremely beneficial for your health. Moong contains almost every important element that your body might need. Buy Moong Dal online today.",
                        "id": 2
                    },
                    {
                        "productName": "Good Life Raw Peanuts 500 g",
                        "price": "89",
                        "oldPrice": "150",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491278616/good-life-raw-peanuts-500-g-product-images-o491278616-p491278616-0-202306102242.jpg",
                        "discount": "16",
                        "brand": "Good Life",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491278616/good-life-raw-peanuts-500-g-product-images-o491278616-p491278616-0-202306102242.jpg",
                            "https://www.jiomart.com/images/product/original/491278616/good-life-raw-peanuts-500-g-product-images-o491278616-p491278616-2-202306102242.jpg",
                            "https://www.jiomart.com/images/product/original/491278616/good-life-raw-peanuts-500-g-product-images-o491278616-p491278616-3-202306102243.jpg",
                            "https://www.jiomart.com/images/product/original/491278616/good-life-raw-peanuts-500-g-product-images-o491278616-p491278616-4-202306102243.jpg",
                            "https://www.jiomart.com/images/product/original/491278616/good-life-raw-peanuts-500-g-product-images-o491278616-p491278616-5-202306102243.jpg"
                        ],
                        "rating": 3.5,
                        "description": "Good Life Raw Peanuts is a healthy snack and the right choice for you. You can easily roast them at home. They are loaded with the goodness of health and taste. Peanut butter made with Peanuts clearly works well in sweet dishes, like cookies and brownies, which is why it pairs well with other sweeter foods like sweet potato. Buy Good Life Raw Peanuts online now!",
                        "id": 3
                    },
                    {
                        "productName": "Tata Sampann Unpolished Chilka Moong 500 g",
                        "price": "74",
                        "oldPrice": "95",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/490830947/tata-sampann-high-protein-unpolished-chilka-moong-500-g-product-images-o490830947-p490830947-0-202203150526.jpg",
                        "discount": "18",
                        "brand": "Tata Sampann",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/490830947/tata-sampann-high-protein-unpolished-chilka-moong-500-g-product-images-o490830947-p490830947-0-202203150526.jpg",
                            "https://www.jiomart.com/images/product/original/490830947/tata-sampann-high-protein-unpolished-chilka-moong-500-g-product-images-o490830947-p490830947-1-202203150526.jpg",
                            "https://www.jiomart.com/images/product/original/490830947/tata-sampann-high-protein-unpolished-chilka-moong-500-g-legal-images-o490830947-p490830947-2-202203150526.jpg",
                            "https://www.jiomart.com/images/product/original/490830947/tata-sampann-high-protein-unpolished-chilka-moong-500-g-legal-images-o490830947-p490830947-5-202203150526.jpg"
                        ],
                        "rating": 4,
                        "description": "Moong Dal is procured from reliable and high-quality sources. The beans are best consumed after being sprouted. Dosa with the whole moong also turns out to be yummy, another exotic way to eat moong is to eat it as a korma which is spiced up with tangy tomatoes and a cashew paste. It is mainly used as the base for curries such as sambar, dal, etc. Buy Tata Sampann Unpolished Chilka Moong online now!",
                        "id": 4
                    },
                    {
                        "productName": "Good Life Moong Dal 1 kg",
                        "price": "145",
                        "oldPrice": "189",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491187257/good-life-moong-dal-1-kg-product-images-o491187257-p491187257-0-202301171616.jpg",
                        "discount": "12",
                        "brand": "Good Life",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491187257/good-life-moong-dal-1-kg-product-images-o491187257-p491187257-0-202301171616.jpg",
                            "https://www.jiomart.com/images/product/original/491187257/good-life-moong-dal-1-kg-product-images-o491187257-p491187257-1-202301171616.jpg",
                            "https://www.jiomart.com/images/product/original/491187257/good-life-moong-dal-1-kg-legal-images-o491187257-p491187257-2-202301171616.jpg"
                        ],
                        "rating": 4.5,
                        "description": "Good life Moong Dal is procured from reliable and high-quality sources. The beans are best consumed after being sprouted. Dosa with whole moong also turns out to be yummy, another exotic way to eat moong is to eat it as a korma which is spiced up with tangy tomatoes and a cashew paste. It is mainly used as the base for curries such as sambar, dal etc. Buy Good Life Moong Dal online now!",
                        "id": 5
                    },
                    {
                        "productName": "Good Life Kabuli Chana 1 kg",
                        "price": "185",
                        "oldPrice": "210",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491187282/good-life-kabuli-chana-1-kg-product-images-o491187282-p491187282-0-202301171615.jpg",
                        "discount": "23",
                        "brand": "Good Life",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491187282/good-life-kabuli-chana-1-kg-product-images-o491187282-p491187282-0-202301171615.jpg",
                            "https://www.jiomart.com/images/product/original/491187282/good-life-kabuli-chana-1-kg-product-images-o491187282-p491187282-1-202301171615.jpg",
                            "https://www.jiomart.com/images/product/original/491187282/good-life-kabuli-chana-1-kg-legal-images-o491187282-p491187282-4-202301171615.jpg"
                        ],
                        "rating": 3.5,
                        "description": "Kabuli Chana is rich in proteins, dietary fibre and low in cholesterol and saturated fat. The beans can be soaked in water and cooked along with vegetables in the preparation of a variety of curries that complement well with rice, roti, chapattis, puri, kulcha as well as bread. It can be sprouted after soaking in water for 24 hours and added to salads to enrich the latter with proteins. Buy Good Life Kabuli Chana online now!",
                        "id": 6
                    },
                    {
                        "productName": "Angur Oily Toor Dal 5Kg",
                        "price": "999",
                        "oldPrice": "1100",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/rv8axdxoiw/angur-oily-toor-dal-5kg-product-images-orv8axdxoiw-p602216568-0-202306071944.jpg",
                        "discount": "16",
                        "brand": "Angur",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/rv8axdxoiw/angur-oily-toor-dal-5kg-product-images-orv8axdxoiw-p602216568-0-202306071944.jpg",
                            "https://www.jiomart.com/images/product/original/rv8axdxoiw/angur-oily-toor-dal-5kg-product-images-orv8axdxoiw-p602216568-1-202306071944.jpg",
                            "https://www.jiomart.com/images/product/original/rv8axdxoiw/angur-oily-toor-dal-5kg-product-images-orv8axdxoiw-p602216568-2-202306071944.jpg",
                            "https://www.jiomart.com/images/product/original/rv8axdxoiw/angur-oily-toor-dal-5kg-product-images-orv8axdxoiw-p602216568-3-202306071944.jpg",
                            "https://www.jiomart.com/images/product/original/rv8axdxoiw/angur-oily-toor-dal-5kg-product-images-orv8axdxoiw-p602216568-4-202306071944.jpg",
                            "https://www.jiomart.com/images/product/original/rv8axdxoiw/angur-oily-toor-dal-5kg-legal-images-orv8axdxoiw-p602216568-5-202306071944.png"
                        ],
                        "rating": 5,
                        "description": "ANGUR TOOR DAL: Toor Dal (split yellow peas) is a mainstay of Indian cuisine. Related to lentils (pulses) and rich in natural nutrients, these delicious legumes are an excellent source of protein, minerals, and B vitamins.ADDS FLAVORFUL PROTEIN: Split yellow peas are an excellent, flavorful protein alternative for any meal. Use as a base or add Toor Dals to your favorite Indian dishes, including curries, soups, stews, salads, and more!",
                        "id": 7
                    },
                    {
                        "productName": "Fortune Soya Wadi / Chunks 1 kg",
                        "price": "139",
                        "oldPrice": "152",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491161236/fortune-soya-wadi-chunks-1-kg-product-images-o491161236-p491161236-0-202303181437.jpg",
                        "discount": "15",
                        "brand": "Fortune",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491161236/fortune-soya-wadi-chunks-1-kg-product-images-o491161236-p491161236-0-202303181437.jpg",
                            "https://www.jiomart.com/images/product/original/491161236/fortune-soya-wadi-chunks-1-kg-product-images-o491161236-p491161236-1-202303181437.jpg",
                            "https://www.jiomart.com/images/product/original/491161236/fortune-soya-wadi-chunks-1-kg-legal-images-o491161236-p491161236-4-202303181437.jpg"
                        ],
                        "rating": 4.5,
                        "description": "Fortune Soya Wadi / Chunks are light, soft and easy on your stomach. Does your family need champion wala dum aur yum? From biryanis to pulao and even Chinese fried rice, cooked soya chunks can be added to numerous rice dishes. Fortune Soya Chunk - ''Yum jo de champion ko dum'', so buy Fortune Soya Wadi / Chunks online now!",
                        "id": 8
                    }
                ]
            },
            {
                "cat_name": "Ghee & Oils",
                "products": [
                    {
                        "productName": "Gowardhan Pure Cow Ghee 1 L (Jar)",
                        "price": "676",
                        "oldPrice": "820",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/490489040/gowardhan-pure-cow-ghee-1-l-jar-product-images-o490489040-p490489040-0-202203170210.jpg",
                        "discount": "18",
                        "brand": "Gowardhan",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/490489040/gowardhan-pure-cow-ghee-1-l-jar-product-images-o490489040-p490489040-0-202203170210.jpg",
                            "https://www.jiomart.com/images/product/original/490489040/gowardhan-pure-cow-ghee-1-l-jar-product-images-o490489040-p490489040-1-202203170210.jpg",
                            "https://www.jiomart.com/images/product/original/490489040/gowardhan-pure-cow-ghee-1-l-jar-product-images-o490489040-p490489040-2-202203170210.jpg",
                            "https://www.jiomart.com/images/product/original/490489040/gowardhan-pure-cow-ghee-1-l-jar-legal-images-o490489040-p490489040-5-202203170210.jpg"
                        ],
                        "rating": 5,
                        "description": "Ghee is a class of clarified butter that originated in ancient India. It is commonly used in Indian cooking. Gowardhan Pure Cow Ghee can be swapped for vegetable oil or coconut oil in baked goods or can be used for deep-frying. Or simply melt it and spread it on roti, or pour it on vegetables/dal before serving. So go ahead and buy this product online today!",
                        "id": 9
                    },
                    {
                        "productName": "Nestle EveryDay Ghee 1 L (Carton)",
                        "price": "579",
                        "oldPrice": "620",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/490440207/nestle-everyday-ghee-1-l-carton-product-images-o490440207-p490440207-0-202203141958.jpg",
                        "discount": "16",
                        "brand": "Nestle",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/490440207/nestle-everyday-ghee-1-l-carton-product-images-o490440207-p490440207-0-202203141958.jpg",
                            "https://www.jiomart.com/images/product/original/490440207/nestle-everyday-ghee-1-l-carton-product-images-o490440207-p490440207-1-202203141958.jpg",
                            "https://www.jiomart.com/images/product/original/490440207/nestle-everyday-ghee-1-l-carton-product-images-o490440207-p490440207-2-202203141958.jpg",
                            "https://www.jiomart.com/images/product/original/490440207/nestle-everyday-ghee-1-l-carton-product-images-o490440207-p490440207-3-202203141958.jpg",
                            "https://www.jiomart.com/images/product/original/490440207/nestle-everyday-ghee-1-l-carton-product-images-o490440207-p490440207-4-202203141958.jpg"
                        ],
                        "rating": 4.5,
                        "description": "Ghee is a class of clarified butter that originated in ancient India. It is commonly used in Indian cooking. Nestle EveryDay Ghee can be swapped for vegetable oil or coconut oil in baked goods or can be used for deep-frying. Or simply melt it and spread it on roti, or pour it on vegetables/dal before serving. So go ahead and buy this product online today!",
                        "id": 10
                    },
                    {
                        "productName": "Amul Cow Ghee 1 L (Pouch)",
                        "price": "250",
                        "oldPrice": "300",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491135471/amul-cow-ghee-1-l-pouch-product-images-o491135471-p491135471-0-202203170918.jpg",
                        "discount": "10",
                        "brand": "Amul",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491135471/amul-cow-ghee-1-l-pouch-product-images-o491135471-p491135471-0-202203170918.jpg",
                            "https://www.jiomart.com/images/product/original/491135471/amul-cow-ghee-1-l-pouch-product-images-o491135471-p491135471-1-202203170918.jpg",
                            "https://www.jiomart.com/images/product/original/491135471/amul-cow-ghee-1-l-pouch-legal-images-o491135471-p491135471-2-202203170918.jpg"
                        ],
                        "rating": 0,
                        "description": "Ghee is a class of clarified butter that originated in ancient India. It is commonly used in Indian cooking. Amul Cow Ghee can be swapped for vegetable oil or coconut oil in baked goods or can be used for deep-frying. Or simply melt it and spread it on roti, or pour it on vegetables/dal before serving. So go ahead and buy this product online today!",
                        "id": 11
                    },
                    {
                        "productName": "Amul Cow Ghee 500 ml (Pouch)",
                        "price": "300",
                        "oldPrice": "380",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/490011305/amul-cow-ghee-500-ml-pouch-product-images-o490011305-p490011305-0-202203150541.jpg",
                        "discount": "8",
                        "brand": "Amul",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/490011305/amul-cow-ghee-500-ml-pouch-product-images-o490011305-p490011305-0-202203150541.jpg",
                            "https://www.jiomart.com/images/product/original/490011305/amul-cow-ghee-500-ml-pouch-product-images-o490011305-p490011305-1-202203150541.jpg"
                        ],
                        "rating": 0,
                        "description": "Ghee is a class of clarified butter that originated in ancient India. It is commonly used in Indian cooking. Amul Cow Ghee can be swapped for vegetable oil or coconut oil in baked goods or can be used for deep-frying. Or simply melt it and spread it on roti, or pour it on vegetables/dal before serving. So go ahead and buy this product online today!",
                        "id": 12
                    },
                    {
                        "productName": "HARYANA FRESH Rich Desi Danedar Ghee 500 Grams (Carton)",
                        "price": "249",
                        "oldPrice": "280",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/rvtancavef/haryana-fresh-rich-desi-danedar-ghee-500-grams-carton-product-images-orvtancavef-p604251677-0-202308302043.jpg",
                        "discount": "18",
                        "brand": "HARYANA FRESH",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/rvtancavef/haryana-fresh-rich-desi-danedar-ghee-500-grams-carton-product-images-orvtancavef-p604251677-0-202308302043.jpg",
                            "https://www.jiomart.com/images/product/original/rvtancavef/haryana-fresh-rich-desi-danedar-ghee-500-grams-carton-product-images-orvtancavef-p604251677-1-202308302043.jpg",
                            "https://www.jiomart.com/images/product/original/rvtancavef/haryana-fresh-rich-desi-danedar-ghee-500-grams-carton-legal-images-orvtancavef-p604251677-2-202308302043.jpg"
                        ],
                        "rating": 4,
                        "description": "Ghee is a class of clarified butter that originated in ancient India. It is commonly used in Indian cooking. Amul Cow Ghee can be swapped for vegetable oil or coconut oil in baked goods or can be used for deep-frying. Or simply melt it and spread it on roti, or pour it on vegetables/dal before serving. So go ahead and buy this product online today",
                        "id": 13
                    },
                    {
                        "productName": "Kheduthaat Shudh Ghee Vedic Method Traditional Suddha Ghee 1 LTR ml",
                        "price": "699",
                        "oldPrice": "780",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/rv6qd7bcjt/kheduthaat-shudh-ghee-vedic-method-traditional-suddha-ghee-1-ltr-ml-product-images-orv6qd7bcjt-p604175636-0-202308291243.jpg",
                        "discount": "14",
                        "brand": "KHEDUT HAAT",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/rv6qd7bcjt/kheduthaat-shudh-ghee-vedic-method-traditional-suddha-ghee-1-ltr-ml-product-images-orv6qd7bcjt-p604175636-0-202308291243.jpg",
                            "https://www.jiomart.com/images/product/original/rv6qd7bcjt/kheduthaat-shudh-ghee-vedic-method-traditional-suddha-ghee-1-ltr-ml-product-images-orv6qd7bcjt-p604175636-1-202308291243.jpg",
                            "https://www.jiomart.com/images/product/original/rv6qd7bcjt/kheduthaat-shudh-ghee-vedic-method-traditional-suddha-ghee-1-ltr-ml-legal-images-orv6qd7bcjt-p604175636-3-202308291243.jpg"
                        ],
                        "rating": 4,
                        "description": "Khedut haat provides you with the pure cow ghee from the milk . Our ghee provides you with all the nutrients needed and only in the vessels made with Soil (Mitti) has taken an initiative for farmers to keep their strength which is a cow. All our products are directly or indirectly related to Cows & Buffalows. this milk to make milk-made dairy products. Cow dung and cow urine for fertilizing the soil. We do not use chemical fertilizers ",
                        "id": 14
                    }
                ]
            },
            {
                "cat_name": "Atta & Flours",
                "products": [
                    {
                        "productName": "Aashirvaad Superior MP Whole Wheat Atta 1 kg",
                        "price": "320",
                        "oldPrice": "380",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/490750659/aashirvaad-superior-mp-whole-wheat-atta-1-kg-product-images-o490750659-p590150646-0-202203150622.jpg",
                        "discount": "13",
                        "brand": "Aashirvaad",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/490750659/aashirvaad-superior-mp-whole-wheat-atta-1-kg-product-images-o490750659-p590150646-0-202203150622.jpg",
                            "https://www.jiomart.com/images/product/original/490750659/aashirvaad-superior-mp-whole-wheat-atta-1-kg-product-images-o490750659-p590150646-1-202203150622.jpg",
                            "https://www.jiomart.com/images/product/original/490750659/aashirvaad-superior-mp-whole-wheat-atta-1-kg-legal-images-o490750659-p590150646-2-202203150622.jpg",
                            "https://www.jiomart.com/images/product/original/490750659/aashirvaad-superior-mp-whole-wheat-atta-1-kg-legal-images-o490750659-p590150646-3-202203150622.jpg",
                            "https://www.jiomart.com/images/product/original/490750659/aashirvaad-superior-mp-whole-wheat-atta-1-kg-legal-images-o490750659-p590150646-4-202203150622.jpg"
                        ],
                        "rating": 5,
                        "description": "Aashirvaad Superior MP Whole Wheat Atta provides goodness of taste in every bite. Also, it has a sweet and aromatic taste that works together to give you fuller and softer rotis, every single time. Buy Aashirvaad Superior MP Whole Wheat Atta online now!",
                        "id": 15
                    },
                    {
                        "productName": "Aashirvaad Select Sharbati Whole Wheat Atta 1 kg",
                        "price": "350",
                        "oldPrice": "380",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/490007352/aashirvaad-select-sharbati-whole-wheat-atta-1-kg-product-images-o490007352-p490007352-0-202206241206.jpg",
                        "discount": "17",
                        "brand": "Aashirvaad",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/490007352/aashirvaad-select-sharbati-whole-wheat-atta-1-kg-product-images-o490007352-p490007352-0-202206241206.jpg",
                            "https://www.jiomart.com/images/product/original/490007352/aashirvaad-select-sharbati-whole-wheat-atta-1-kg-product-images-o490007352-p490007352-1-202206241206.jpg",
                            "https://www.jiomart.com/images/product/original/490007352/aashirvaad-select-sharbati-whole-wheat-atta-1-kg-legal-images-o490007352-p490007352-2-202206241206.jpg",
                            "https://www.jiomart.com/images/product/original/490007352/aashirvaad-select-sharbati-whole-wheat-atta-1-kg-legal-images-o490007352-p490007352-3-202206241206.jpg"
                        ],
                        "rating": 0,
                        "description": "Aashirvaad ensures that only superior quality ingredients reach your kitchen and Aashirvaad Select Sharbati stays true to that word. Made from the King of Wheat Sharbati, Aashirvaad Select is a premium quality aata which is made with love in India. This sharbati wheat flour contains MP Sharbati wheat from the select regions of Madhya Pradesh. The grains of sharabati atta are consistent in size and have a golden sheen to it. The dough made from the King of Wheat Sharbati, absorbs more water which leads to the rotis being sweet in taste and softer in texture. Buy Aashirvaad Select Sharbati Whole Wheat Atta now!",
                        "id": 16
                    },
                    {
                        "productName": "Aashirvaad Superior MP Whole Wheat Atta 2 kg",
                        "price": "250",
                        "oldPrice": "300",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/490750660/aashirvaad-superior-mp-whole-wheat-atta-2-kg-product-images-o490750660-p590150647-0-202203170807.jpg",
                        "discount": "12",
                        "brand": "Aashirvaad",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/490750660/aashirvaad-superior-mp-whole-wheat-atta-2-kg-product-images-o490750660-p590150647-0-202203170807.jpg",
                            "https://www.jiomart.com/images/product/original/490750660/aashirvaad-superior-mp-whole-wheat-atta-2-kg-product-images-o490750660-p590150647-1-202203170807.jpg",
                            "https://www.jiomart.com/images/product/original/490750660/aashirvaad-superior-mp-whole-wheat-atta-2-kg-legal-images-o490750660-p590150647-2-202203170807.jpg",
                            "https://www.jiomart.com/images/product/original/490750660/aashirvaad-superior-mp-whole-wheat-atta-2-kg-legal-images-o490750660-p590150647-3-202203170807.jpg"
                        ],
                        "rating": 4.5,
                        "description": "Aashirvaad Superior MP Whole Wheat Atta provides goodness of taste in every bite. Also, it has a sweet and aromatic taste that works together to give you fuller and softer rotis, every single time. Buy Aashirvaad Superior MP Whole Wheat Atta online now!\n",
                        "id": 17
                    },
                    {
                        "productName": "Chakki Atta 10 kg",
                        "price": "400",
                        "oldPrice": "450",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491349660/chakki-atta-10-kg-product-images-o491349660-p491349660-0-202206231932.jpg",
                        "discount": "12",
                        "brand": "Private Label",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491349660/chakki-atta-10-kg-product-images-o491349660-p491349660-0-202206231932.jpg",
                            "https://www.jiomart.com/images/product/original/491349660/chakki-atta-10-kg-product-images-o491349660-p491349660-1-202206231932.jpg"
                        ],
                        "rating": 4,
                        "description": "Chakki Atta is freshly made from the choicest grains. It is carefully ground using modern chakki technique. It is used to make a wide range of foods including bread, crumpets, muffins, noodles, pasta, biscuits, cakes, pastries, cereal bars, sweet and savoury snack foods, crackers, crisp-breads, sauces and confectioner. Buy Chakki Atta online now!\n",
                        "id": 18
                    },
                    {
                        "productName": "Good Life MP Wheat Chakki Atta 5 kg",
                        "price": "250",
                        "oldPrice": "280",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491458272/good-life-mp-wheat-chakki-atta-5-kg-product-images-o491458272-p491458272-0-202306131322.jpg",
                        "discount": "12",
                        "brand": "Good Life",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491458272/good-life-mp-wheat-chakki-atta-5-kg-product-images-o491458272-p491458272-0-202306131322.jpg",
                            "https://www.jiomart.com/images/product/original/491458272/good-life-mp-wheat-chakki-atta-5-kg-product-images-o491458272-p491458272-1-202306131322.jpg",
                            "https://www.jiomart.com/images/product/original/491458272/good-life-mp-wheat-chakki-atta-5-kg-product-images-o491458272-p491458272-2-202306131322.jpg",
                            "https://www.jiomart.com/images/product/original/491458272/good-life-mp-wheat-chakki-atta-5-kg-legal-images-o491458272-p491458272-3-202306131322.jpg"
                        ],
                        "rating": 4,
                        "description": "Now get the best of health in every bite with Good Life MP Wheat Chakki Atta. The hygienic packaging ensures the product remains fresh over a period of time. Also, it has a sweet and aromatic taste that works together to give you fuller and softer rotis, every single time. Buy Good Life MP Wheat Chakki Atta online now!\n",
                        "id": 19
                    },
                    {
                        "productName": "Fortune Suji / Semolina 500 g",
                        "price": "26",
                        "oldPrice": "35",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491695704/fortune-suji-semolina-500-g-product-images-o491695704-p590040931-0-202305191005.jpg",
                        "discount": "12",
                        "brand": "Fortune",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491695704/fortune-suji-semolina-500-g-product-images-o491695704-p590040931-0-202305191005.jpg",
                            "https://www.jiomart.com/images/product/original/491695704/fortune-suji-semolina-500-g-product-images-o491695704-p590040931-1-202305191005.jpg",
                            "https://www.jiomart.com/images/product/original/491695704/fortune-suji-semolina-500-g-legal-images-o491695704-p590040931-2-202305191005.jpg"
                        ],
                        "rating": 5,
                        "description": "Fortune Suji / Semolina commonly called as wheat rawa is used as a batter ingredient as well as to make various other food items like upma and sheera. It is coarse in texture and is made of wheat. It is a versatile ingredient and easy to cook. It makes a perfect food for breakfast. Buy Fortune Suji / Semolina online now!\n",
                        "id": 20
                    },
                    {
                        "productName": "Wheatkart Whole Wheat Atta - 10 KG",
                        "price": "210",
                        "oldPrice": "250",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/rvondh0dpy/wheatkart-whole-wheat-atta-10-kg-product-images-orvondh0dpy-p596562517-0-202212221536.png",
                        "discount": "17",
                        "brand": "Wheatkart",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/rvondh0dpy/wheatkart-whole-wheat-atta-10-kg-product-images-orvondh0dpy-p596562517-0-202212221536.png",
                            "https://www.jiomart.com/images/product/original/rvondh0dpy/wheatkart-whole-wheat-atta-10-kg-legal-images-orvondh0dpy-p596562517-1-202212221536.png"
                        ],
                        "rating": 4.5,
                        "description": "Without adding any maida, we have 100% wheat flour to make the dough smoother.\n\nThe atta is so perfectly blended that the chappatis made by Wheatkart Atta are tastier and softer when they are cold.\n\nAtta or chakki atta is wheat flour from the Indian subcontinent that is mostly used to create flatbreads like chapati, roti, naan, paratha and puri.",
                        "id": 21
                    }
                ]
            },
            {
                "cat_name": "masalas spices",
                "products": [
                    {
                        "productName": "Good Life Jeera 100 g",
                        "price": "300",
                        "oldPrice": "350",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491185109/good-life-jeera-100-g-product-images-o491185109-p491185109-0-202306131531.jpg",
                        "discount": "10",
                        "brand": "Good Life ",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491185109/good-life-jeera-100-g-product-images-o491185109-p491185109-0-202306131531.jpg",
                            "https://www.jiomart.com/images/product/original/491185109/good-life-jeera-100-g-product-images-o491185109-p491185109-1-202306131531.jpg",
                            "https://www.jiomart.com/images/product/original/491185109/good-life-jeera-100-g-product-images-o491185109-p491185109-2-202306131531.jpg",
                            "https://www.jiomart.com/images/product/original/491185109/good-life-jeera-100-g-legal-images-o491185109-p491185109-3-202306131531.jpg"
                        ],
                        "rating": 4.5,
                        "description": "eera is an essential spice that is used for tempering dishes with a strong taste and aroma. It offers a sturdy, exclusive and soothing piquancy and aroma to the dishes. It's not only known for its flavour enhancing quality but also for its health benefits. Add an extra pinch of taste to your dish with Good Life Jeera. So go ahead and buy this product online today.",
                        "id": 22
                    },
                    {
                        "productName": "Maggi Masala Ae Magic 6 g (Pack of 12)",
                        "price": "200",
                        "oldPrice": "250",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491410091/maggi-masala-ae-magic-6-g-pack-of-12-product-images-o491410091-p491410091-0-202305181146.jpg",
                        "discount": "10",
                        "brand": "Maggi",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491410091/maggi-masala-ae-magic-6-g-pack-of-12-product-images-o491410091-p491410091-0-202305181146.jpg",
                            "https://www.jiomart.com/images/product/original/491410091/maggi-masala-ae-magic-6-g-pack-of-12-product-images-o491410091-p491410091-1-202305181146.jpg",
                            "https://www.jiomart.com/images/product/original/491410091/maggi-masala-ae-magic-6-g-pack-of-12-product-images-o491410091-p491410091-2-202305181146.jpg",
                            "https://www.jiomart.com/images/product/original/491410091/maggi-masala-ae-magic-6-g-pack-of-12-product-images-o491410091-p491410091-3-202305181146.jpg",
                            "https://www.jiomart.com/images/product/original/491410091/maggi-masala-ae-magic-6-g-pack-of-12-legal-images-o491410091-p491410091-4-202305181146.jpg"
                        ],
                        "rating": 5,
                        "description": "Maggi Masala Ae Magic is that secret spice that instantly enhances the taste and aroma of any dish. Just add a teaspoon of this spice to flavoured rice, vegetable dishes, salads and snacks to make them flavoursome. Buy Maggi Masala Ae Magic online now!",
                        "id": 23
                    },
                    {
                        "productName": "Good Life Compounded Hing Powder 50 g",
                        "price": "55",
                        "oldPrice": "85",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491279754/good-life-compounded-hing-powder-50-g-product-images-o491279754-p491279754-0-202205180454.jpg",
                        "discount": "10",
                        "brand": "Good Life",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491279754/good-life-compounded-hing-powder-50-g-product-images-o491279754-p491279754-0-202205180454.jpg",
                            "https://www.jiomart.com/images/product/original/491279754/good-life-compounded-hing-powder-50-g-product-images-o491279754-p491279754-1-202205180454.jpg",
                            "https://www.jiomart.com/images/product/original/491279754/good-life-compounded-hing-powder-50-g-product-images-o491279754-p491279754-2-202205180454.jpg",
                            "https://www.jiomart.com/images/product/original/491279754/good-life-compounded-hing-powder-50-g-product-images-o491279754-p491279754-3-202205180454.jpg"
                        ],
                        "rating": 4,
                        "description": "Hing (Asafoetida) has a slightly pungent smell but when added to pickles and curries it gives a delectable flavour. A tinge of Hing can turn your food more flavourful. The product helps in easy digestion too. Good Life Compounded Hing Powder serves as an ideal choice for all your cooking needs. Buy this product online today.",
                        "id": 24
                    },
                    {
                        "productName": "VEEDINT CUMIN SEEDS, JEERA WHOLE, CUMIN SEED WHOLE, 1 KG PACK",
                        "price": "180",
                        "oldPrice": "220",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/rvahttucjx/veedint-cumin-seeds-jeera-whole-cumin-seed-whole-1-kg-pack-product-images-orvahttucjx-p601512221-0-202305151313.jpg",
                        "discount": "10",
                        "brand": "Veedint",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/rvahttucjx/veedint-cumin-seeds-jeera-whole-cumin-seed-whole-1-kg-pack-product-images-orvahttucjx-p601512221-0-202305151313.jpg",
                            "https://www.jiomart.com/images/product/original/rvahttucjx/veedint-cumin-seeds-jeera-whole-cumin-seed-whole-1-kg-pack-product-images-orvahttucjx-p601512221-1-202305151313.jpg",
                            "https://www.jiomart.com/images/product/original/rvahttucjx/veedint-cumin-seeds-jeera-whole-cumin-seed-whole-1-kg-pack-product-images-orvahttucjx-p601512221-2-202305151313.jpg"
                        ],
                        "rating": 5,
                        "description": "Cumin Seed Whole (Jeera), Natural. Cumin seeds are commonly used in Indian and South Asian cooking, as well as Mexican cuisine. They have a warm and aromatic flavor that resembles curry powder. The seeds are used as a key ingredient in Indian food, but can also be added to soups or sauces for flavoring purposes. The aromatic seed like fruit is elongated, ovoid, 3-6 mm long, slingtly bitter and has a warm flavour The flowers are white or rose coloured in small umbels. \n",
                        "id": 25
                    },
                    {
                        "productName": "Organic Tattva Cumin Seeds 100 g",
                        "price": "88",
                        "oldPrice": "110",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491229671/organic-tattva-cumin-seeds-100-g-product-images-o491229671-p491229671-0-202206021941.jpg",
                        "discount": "8",
                        "brand": "Organic Tattva",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491229671/organic-tattva-cumin-seeds-100-g-product-images-o491229671-p491229671-0-202206021941.jpg",
                            "https://www.jiomart.com/images/product/original/491229671/organic-tattva-cumin-seeds-100-g-product-images-o491229671-p491229671-1-202206021941.jpg"
                        ],
                        "rating": 5,
                        "description": "Cumin seeds or Jeera is an essential spice that is used for tempering dishes with a strong taste and aroma. It offers a sturdy, exclusive and soothing piquancy and aroma to the dishes. It's not only known for its flavour enhancing quality but also for its health benefits. Add an extra pinch of taste to your dish with Organic Tattva Cumin Seeds. So go ahead and buy this product online today.\n",
                        "id": 26
                    },
                    {
                        "productName": "Lotus Spices Green Elaichi 10 g",
                        "price": "32",
                        "oldPrice": "55",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/493072642/lotus-spices-green-elaichi-15-g-product-images-o493072642-p593731219-0-202304291358.jpg",
                        "discount": "10",
                        "brand": "Lotus",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/493072642/lotus-spices-green-elaichi-15-g-product-images-o493072642-p593731219-0-202304291358.jpg",
                            "https://www.jiomart.com/images/product/original/493072642/lotus-spices-green-elaichi-15-g-product-images-o493072642-p593731219-1-202304291358.jpg"
                        ],
                        "rating": 4.5,
                        "description": "Green Elaichi or Green Cardamom is also known as the 'Queen of Spices'. It is the most common spice used in a variety of sweet and savoury dishes. It is also added to tea and coffee for its unique fragrance and flavour. Buy Lotus Spices Green Elaichi online today!\n",
                        "id": 27
                    }
                ]
            },
            {
                "cat_name": "Rice & Rice Products",
                "products": [
                    {
                        "productName": "Tata Sampann White Poha 500 g",
                        "price": "140",
                        "oldPrice": "180",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491614721/tata-sampann-white-poha-500-g-product-images-o491614721-p491614721-0-202203150346.jpg",
                        "discount": "20",
                        "brand": "Tata Sampann",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491614721/tata-sampann-white-poha-500-g-product-images-o491614721-p491614721-0-202203150346.jpg",
                            "https://www.jiomart.com/images/product/original/491614721/tata-sampann-white-poha-500-g-product-images-o491614721-p491614721-1-202203150346.jpg"
                        ],
                        "rating": 5,
                        "description": "Poha (Rice Flakes) is a popular Indian breakfast, especially for those who are on a weight watch. It is made from beaten rice. Serve a hot plate of delicious poha topped with bhujia and coriander, along with a bowl of green chutney for your breakfast or snack time. Buy Tata Sampann White Poha online now!\n",
                        "id": 30
                    },
                    {
                        "productName": "Daawat Rozana Super Basmati Broken Rice 1 kg",
                        "price": "150",
                        "oldPrice": "190",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/490863714/daawat-rozana-super-basmati-rice-1-kg-product-images-o490863714-p490863714-0-202203171018.jpg",
                        "discount": "12",
                        "brand": "Daawat",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/490863714/daawat-rozana-super-basmati-rice-1-kg-product-images-o490863714-p490863714-0-202203171018.jpg",
                            "https://www.jiomart.com/images/product/original/490863714/daawat-rozana-super-basmati-rice-1-kg-product-images-o490863714-p490863714-1-202203171018.jpg",
                            "https://www.jiomart.com/images/product/original/490863714/daawat-rozana-super-basmati-rice-1-kg-legal-images-o490863714-p490863714-2-202203171018.jpg"
                        ],
                        "rating": 4,
                        "description": "Basmati Broken Rice has been an integral part of different Broken Rice recipes in every Indian household. It is processed under the supervision of experts. It can be used in a variety of Broken Rice dishes including biryani, pulao, and other Indian dishes. One can have it with meat, curries, dals and many more food items. Buy Daawat Rozana Super Basmati Broken Rice online now!\n",
                        "id": 31
                    },
                    {
                        "productName": "Elina Long Grain Rice 1 kg",
                        "price": "140",
                        "oldPrice": "160",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491173885/elina-long-grain-rice-1-kg-product-images-o491173885-p491173885-0-202203151443.jpg",
                        "discount": "10",
                        "brand": "Elina",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491173885/elina-long-grain-rice-1-kg-product-images-o491173885-p491173885-0-202203151443.jpg",
                            "https://www.jiomart.com/images/product/original/491173885/elina-long-grain-rice-1-kg-product-images-o491173885-p491173885-1-202203151443.jpg",
                            "https://www.jiomart.com/images/product/original/491173885/elina-long-grain-rice-1-kg-legal-images-o491173885-p491173885-2-202203151443.jpg"
                        ],
                        "rating": 4,
                        "description": "Guests coming over for dinner? Put on your cooking aprons and cook some delicious rice recipes with Elina Long Grain Rice. The slender long grained rice is aromatic and nutritious at the same time. Its flavourful rich taste will earn you lots of appreciation from your visitors. It is a premium brand that focuses on providing good quality products at affordable rates. Buy Elina Long Grain Rice online now!\n\n",
                        "id": 32
                    },
                    {
                        "productName": "Daawat Rozana Gold Basmati Broken Rice 5 kg",
                        "price": "130",
                        "oldPrice": "170",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/490005638/daawat-rozana-gold-basmati-rice-5-kg-product-images-o490005638-p490005638-0-202203171005.jpg",
                        "discount": "8",
                        "brand": "Daawat",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/490005638/daawat-rozana-gold-basmati-rice-5-kg-product-images-o490005638-p490005638-0-202203171005.jpg",
                            "https://www.jiomart.com/images/product/original/490005638/daawat-rozana-gold-basmati-rice-5-kg-product-images-o490005638-p490005638-1-202203171005.jpg",
                            "https://www.jiomart.com/images/product/original/490005638/daawat-rozana-gold-basmati-rice-5-kg-legal-images-o490005638-p490005638-2-202203171005.jpg"
                        ],
                        "rating": 5,
                        "description": "Daawat Rozana Gold Basmati Broken Rice has been an integral part of different Broken Rice recipes in every Indian household. It is processed under the supervision of experts. It can be used in a variety of Broken Rice dishes including biryani, pulao, and other Indian dishes. One can have it with meat, curries, dals and many more food items. Buy Daawat Rozana Gold Basmati Broken Rice online now!\n",
                        "id": 33
                    },
                    {
                        "productName": "Daawat Rozana Super Basmati Broken Rice 5 kg",
                        "price": "100",
                        "oldPrice": "130",
                        "weight": [
                            50,
                            100,
                            150,
                            200,
                            250,
                            500
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491019524/daawat-rozana-super-basmati-rice-5-kg-product-images-o491019524-p491019524-0-202203171025.jpg",
                        "discount": "10",
                        "brand": "Daawat",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491019524/daawat-rozana-super-basmati-rice-5-kg-product-images-o491019524-p491019524-0-202203171025.jpg",
                            "https://www.jiomart.com/images/product/original/491019524/daawat-rozana-super-basmati-rice-5-kg-product-images-o491019524-p491019524-1-202203171025.jpg",
                            "https://www.jiomart.com/images/product/original/491019524/daawat-rozana-super-basmati-rice-5-kg-legal-images-o491019524-p491019524-2-202203171025.jpg"
                        ],
                        "rating": 4.5,
                        "description": "Basmati Broken Rice is everyday Broken Rice that makes each meal memorable. It is ideal for people who like to include Broken Rice in their daily meal consumption. Aromatic, flavourful, and defined by its distinctly long and slender grains, Daawat Rozana Super Basmati Broken Rice turns every meal into comfort food. Go and grab your pack now! Buy Daawat Rozana Super Basmati Broken Rice online now!\n",
                        "id": 34
                    }
                ]
            }
        ]
    },
    {
        "cat_name": "Electronics",
        "id": "2",
        "image": "https://cdn-icons-png.flaticon.com/128/3659/3659898.png",
        "items": [
            {
                "cat_name": "Mobiles & Tablets",
                "products": [
                    {
                        "productName": "OnePlus Nord CE 2 Lite 5G,128 GB,6 GB RAM,Blue Tide,Mobile Phone",
                        "price": "16,999.00",
                        "oldPrice": "19,999.00",
                        "weight": [],
                        "RAM": [
                            4,
                            6,
                            8
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/492850035/oneplus-nord-ce-2-lite-5g-128-gb-6-gb-ram-blue-tide-mobile-phone-digital-o492850035-p591224603-0-202208112007.png",
                        "discount": "12",
                        "brand": "One Plus",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/492850035/oneplus-nord-ce-2-lite-5g-128-gb-6-gb-ram-blue-tide-mobile-phone-digital-o492850035-p591224603-0-202208112007.png",
                            "https://www.jiomart.com/images/product/original/492850035/oneplus-nord-ce-2-lite-5g-128-gb-6-gb-ram-blue-tide-mobile-phone-digital-o492850035-p591224603-0-202208112007.png",
                            "https://www.jiomart.com/images/product/original/492850035/oneplus-nord-ce-2-lite-5g-128-gb-6-gb-ram-blue-tide-mobile-phone-digital-o492850035-p591224603-1-202208112007.jpeg",
                            "https://www.jiomart.com/images/product/original/492850035/oneplus-nord-ce-2-lite-5g-128-gb-6-gb-ram-blue-tide-mobile-phone-digital-o492850035-p591224603-2-202208112007.jpeg",
                            "https://www.jiomart.com/images/product/original/492850035/oneplus-nord-ce-2-lite-5g-128-gb-6-gb-ram-blue-tide-mobile-phone-digital-o492850035-p591224603-3-202208112007.jpeg",
                            "https://www.jiomart.com/images/product/original/492850035/oneplus-nord-ce-2-lite-5g-128-gb-6-gb-ram-blue-tide-mobile-phone-digital-o492850035-p591224603-4-202208112007.jpeg",
                            "https://www.jiomart.com/images/product/original/492850035/oneplus-nord-ce-2-lite-5g-128-gb-6-gb-ram-blue-tide-mobile-phone-digital-o492850035-p591224603-5-202208112007.png",
                            "https://www.jiomart.com/images/product/original/492850035/oneplus-nord-ce-2-lite-5g-128-gb-6-gb-ram-blue-tide-mobile-phone-digital-o492850035-p591224603-6-202208112007.png"
                        ],
                        "rating": 4.5,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 35
                    },
                    {
                        "productName": "Apple iPhone 13 128 GB, Midnight (Black)",
                        "price": "56,900.00",
                        "oldPrice": "59,900.00",
                        "weight": [],
                        "RAM": [
                            4,
                            6,
                            8,
                            12
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/491997699/apple-iphone-13-128-gb-midnight-black-digital-o491997699-p590798548-0-202208221207.jpeg",
                        "discount": "20",
                        "brand": "Apple",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/491997699/apple-iphone-13-128-gb-midnight-black-digital-o491997699-p590798548-0-202208221207.jpeg",
                            "https://www.jiomart.com/images/product/original/491997699/apple-iphone-13-128-gb-midnight-black-digital-o491997699-p590798548-1-202208221207.jpeg",
                            "https://www.jiomart.com/images/product/original/491997699/apple-iphone-13-128-gb-midnight-black-digital-o491997699-p590798548-2-202208221207.jpeg",
                            "https://www.jiomart.com/images/product/original/491997699/apple-iphone-13-128-gb-midnight-black-digital-o491997699-p590798548-3-202208221207.jpeg",
                            "https://www.jiomart.com/images/product/original/491997699/apple-iphone-13-128-gb-midnight-black-digital-o491997699-p590798548-4-202208221207.jpeg"
                        ],
                        "rating": 4.5,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 36
                    },
                    {
                        "productName": "Tecno Pop 7 Pro 64 GB, 2 GB, Black, Smartphone",
                        "price": "5,555.00",
                        "oldPrice": "7,999.00 ",
                        "weight": [],
                        "RAM": [
                            4,
                            6,
                            8,
                            12
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/494267984/tecno-pop-7-pro-64-gb-2-gb-black-smartphone-digital-o494267984-p605156024-0-202309292014.jpeg",
                        "discount": "16",
                        "brand": "Tecno",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/494267984/tecno-pop-7-pro-64-gb-2-gb-black-smartphone-digital-o494267984-p605156024-0-202309292014.jpeg",
                            "https://www.jiomart.com/images/product/original/494267984/tecno-pop-7-pro-64-gb-2-gb-black-smartphone-digital-o494267984-p605156024-1-202309292014.jpeg",
                            "https://www.jiomart.com/images/product/original/494267984/tecno-pop-7-pro-64-gb-2-gb-black-smartphone-digital-o494267984-p605156024-2-202309292014.jpeg",
                            "https://www.jiomart.com/images/product/original/494267984/tecno-pop-7-pro-64-gb-2-gb-black-smartphone-digital-o494267984-p605156024-3-202309292014.jpeg",
                            "https://www.jiomart.com/images/product/original/494267984/tecno-pop-7-pro-64-gb-2-gb-black-smartphone-digital-o494267984-p605156024-4-202309292014.jpeg"
                        ],
                        "rating": 4.2,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 37
                    },
                    {
                        "productName": "Realme C55 DLC 64GB, 4 GB RAM, Sunshower, Mobile Phone",
                        "price": "10,299.00",
                        "oldPrice": "12,999.00 ",
                        "weight": [],
                        "RAM": [
                            4,
                            6,
                            8,
                            12
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/494267979/realme-c55-dlc-64gb-4-gb-ram-sunshower-mobile-phone-digital-o494267979-p605449884-0-202310051633.jpeg",
                        "discount": "16",
                        "brand": "Realme",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/494267979/realme-c55-dlc-64gb-4-gb-ram-sunshower-mobile-phone-digital-o494267979-p605449884-0-202310051633.jpeg",
                            "https://www.jiomart.com/images/product/original/494267979/realme-c55-dlc-64gb-4-gb-ram-sunshower-mobile-phone-digital-o494267979-p605449884-1-202310051633.jpeg",
                            "https://www.jiomart.com/images/product/original/494267979/realme-c55-dlc-64gb-4-gb-ram-sunshower-mobile-phone-digital-o494267979-p605449884-2-202310051633.jpeg",
                            "https://www.jiomart.com/images/product/original/494267979/realme-c55-dlc-64gb-4-gb-ram-sunshower-mobile-phone-digital-o494267979-p605449884-3-202310051633.jpeg",
                            "https://www.jiomart.com/images/product/original/494267979/realme-c55-dlc-64gb-4-gb-ram-sunshower-mobile-phone-digital-o494267979-p605449884-4-202310051633.jpeg"
                        ],
                        "rating": 4.5,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 38
                    },
                    {
                        "productName": "POCO M6 Pro 5G, 6GB RAM, 128GB ROM, Power Black, Smartphone",
                        "price": "12,199.00",
                        "oldPrice": "16,999.00",
                        "weight": [],
                        "RAM": [
                            4,
                            6,
                            8,
                            12
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/rvqxs1lbdt/poco-m6-pro-5g-6gb-ram-128gb-rom-power-black-smartphone-product-images-orvqxs1lbdt-p604649284-0-202309191411.jpg",
                        "discount": "10",
                        "brand": "POCO",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/rvqxs1lbdt/poco-m6-pro-5g-6gb-ram-128gb-rom-power-black-smartphone-product-images-orvqxs1lbdt-p604649284-0-202309191411.jpg",
                            "https://www.jiomart.com/images/product/original/rvqxs1lbdt/poco-m6-pro-5g-6gb-ram-128gb-rom-power-black-smartphone-product-images-orvqxs1lbdt-p604649284-1-202309191411.jpg"
                        ],
                        "rating": 4.5,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 39
                    }
                ]
            },
            {
                "cat_name": "TV & Speaker",
                "products": [
                    {
                        "productName": "Realme 80 cm (32 inch) HD Ready LED Smart Android TV 2023 Edition with Android 11 RMV2205",
                        "price": "9,990.00",
                        "oldPrice": "21,999.00 ",
                        "weight": [],
                        "RAM": [],
                        "SIZE": [
                            "32 inch",
                            "43 inch"
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/494249596/realme-80-cm-32-inch-hd-ready-led-smart-android-tv-2023-edition-with-android-11-rmv2205-digital-o494249596-p604838497-0-202309262030.jpeg",
                        "discount": "16",
                        "brand": "Realme",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/494249596/realme-80-cm-32-inch-hd-ready-led-smart-android-tv-2023-edition-with-android-11-rmv2205-digital-o494249596-p604838497-0-202309262030.jpeg",
                            "https://www.jiomart.com/images/product/original/494249596/realme-80-cm-32-inch-hd-ready-led-smart-android-tv-2023-edition-with-android-11-rmv2205-digital-o494249596-p604838497-1-202309262030.jpeg",
                            "https://www.jiomart.com/images/product/original/494249596/realme-80-cm-32-inch-hd-ready-led-smart-android-tv-2023-edition-with-android-11-rmv2205-digital-o494249596-p604838497-2-202309262030.jpeg",
                            "https://www.jiomart.com/images/product/original/494249596/realme-80-cm-32-inch-hd-ready-led-smart-android-tv-2023-edition-with-android-11-rmv2205-digital-o494249596-p604838497-3-202309262030.jpeg)"
                        ],
                        "rating": 4.5,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 40
                    },
                    {
                        "productName": "Realme 80 cm (32 inch) HD Ready LED Smart Android TV 2023 Edition with Android 11 RMV2205",
                        "price": "9,990.00",
                        "oldPrice": "21,999.00 ",
                        "weight": [],
                        "RAM": [],
                        "SIZE": [
                            "32 inch",
                            "43 inch"
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/494249596/realme-80-cm-32-inch-hd-ready-led-smart-android-tv-2023-edition-with-android-11-rmv2205-digital-o494249596-p604838497-0-202309262030.jpeg",
                        "discount": "16",
                        "brand": "Realme",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/494249596/realme-80-cm-32-inch-hd-ready-led-smart-android-tv-2023-edition-with-android-11-rmv2205-digital-o494249596-p604838497-0-202309262030.jpeg",
                            "https://www.jiomart.com/images/product/original/494249596/realme-80-cm-32-inch-hd-ready-led-smart-android-tv-2023-edition-with-android-11-rmv2205-digital-o494249596-p604838497-1-202309262030.jpeg",
                            "https://www.jiomart.com/images/product/original/494249596/realme-80-cm-32-inch-hd-ready-led-smart-android-tv-2023-edition-with-android-11-rmv2205-digital-o494249596-p604838497-2-202309262030.jpeg",
                            "https://www.jiomart.com/images/product/original/494249596/realme-80-cm-32-inch-hd-ready-led-smart-android-tv-2023-edition-with-android-11-rmv2205-digital-o494249596-p604838497-3-202309262030.jpeg"
                        ],
                        "rating": 4.5,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 41
                    },
                    {
                        "productName": "OnePlus 108 cm (43 inch) Full HD Android Smart LED TV with Dolby Audio Surround Sound Technology, 43Y1S Edge",
                        "price": "22,990.00",
                        "oldPrice": "33,999.00",
                        "weight": [],
                        "RAM": [],
                        "SIZE": [
                            "32 inch",
                            "43 inch"
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/492796557/oneplus-108-cm-43-inch-full-hd-android-smart-led-tv-with-dolby-audio-surround-sound-technology-43y1s-edge-digital-o492796557-p591054038-0-202202221339.jpeg",
                        "discount": "32",
                        "brand": "One Plus",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/492796557/oneplus-108-cm-43-inch-full-hd-android-smart-led-tv-with-dolby-audio-surround-sound-technology-43y1s-edge-digital-o492796557-p591054038-0-202202221339.jpeg",
                            "https://www.jiomart.com/images/product/original/492796557/oneplus-108-cm-43-inch-full-hd-android-smart-led-tv-with-dolby-audio-surround-sound-technology-43y1s-edge-digital-o492796557-p591054038-1-202202221339.jpeg",
                            "https://www.jiomart.com/images/product/original/492796557/oneplus-108-cm-43-inch-full-hd-android-smart-led-tv-with-dolby-audio-surround-sound-technology-43y1s-edge-digital-o492796557-p591054038-2-202202221339.jpeg",
                            "https://www.jiomart.com/images/product/original/492796557/oneplus-108-cm-43-inch-full-hd-android-smart-led-tv-with-dolby-audio-surround-sound-technology-43y1s-edge-digital-o492796557-p591054038-3-202202221339.jpeg"
                        ],
                        "rating": 4.5,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 42
                    },
                    {
                        "productName": "TCL 55 QLED Smart Google TV, 55C645",
                        "price": "39,990.00",
                        "oldPrice": "121,990.00",
                        "weight": [],
                        "RAM": [],
                        "SIZE": [
                            "32 inch",
                            "43 inch"
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/493841840/tcl-55-qled-smart-google-tv-55c645-digital-o493841840-p601697284-0-202305221948.png",
                        "discount": "32",
                        "brand": "TCL",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/493841840/tcl-55-qled-smart-google-tv-55c645-digital-o493841840-p601697284-0-202305221948.png"
                        ],
                        "rating": 4,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 43
                    }
                ]
            }
        ]
    },
    {
        "cat_name": "Fashion",
        "id": "3",
        "image": "https://cdn-icons-png.flaticon.com/128/12516/12516451.png",
        "items": [
            {
                "cat_name": "Men Western Wear",
                "products": [
                    {
                        "productName": "Bomber Jacket with Zipper Pockets",
                        "price": "1,593.00",
                        "oldPrice": "3,125.00  ",
                        "weight": [],
                        "RAM": [],
                        "SIZE": [
                            "M",
                            "L",
                            "XL",
                            "XXL"
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/469255919_black/bomber-jacket-with-zipper-pockets-model-469255919_black-0-202301311905.jpg",
                        "discount": "49",
                        "brand": "Fort Collins",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/469255919_black/bomber-jacket-with-zipper-pockets-model-469255919_black-0-202301311905.jpg",
                            "https://www.jiomart.com/images/product/original/469255919_black/bomber-jacket-with-zipper-pockets-model2-469255919_black-2-202301311905.jpg",
                            "https://www.jiomart.com/images/product/original/469255919_black/bomber-jacket-with-zipper-pockets-model3-469255919_black-3-202301311905.jpg",
                            "https://www.jiomart.com/images/product/original/469255919_black/bomber-jacket-with-zipper-pockets-model4-469255919_black-4-202301311905.jpg"
                        ],
                        "rating": 4.5,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 44
                    },
                    {
                        "productName": "Mid-Rise Skinny Fit Jeans",
                        "price": "269.00",
                        "oldPrice": "899.00",
                        "weight": [],
                        "RAM": [],
                        "SIZE": [
                            28,
                            30,
                            32,
                            34
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/420434311_blue/skinny-jeans-with-button-closure-model-420434311_blue-0-202308081627.jpg",
                        "discount": "49",
                        "brand": "Fort Collins",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/420434311_blue/skinny-jeans-with-button-closure-model-420434311_blue-0-202308081627.jpg",
                            "https://www.jiomart.com/images/product/original/420434311_blue/skinny-jeans-with-button-closure-model2-420434311_blue-2-202308081627.jpg",
                            "https://www.jiomart.com/images/product/original/420434311_blue/skinny-jeans-with-button-closure-model3-420434311_blue-3-202308081627.jpg",
                            "https://www.jiomart.com/images/product/original/420434311_blue/skinny-jeans-with-button-closure-model4-420434311_blue-4-202308081627.jpg",
                            "https://www.jiomart.com/images/product/original/420434311_blue/skinny-jeans-with-button-closure-model5-420434311_blue-5-202308081627.jpg"
                        ],
                        "rating": 5,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 45
                    },
                    {
                        "productName": "Plutus Men Black Solid Polyester Casual Jacket M",
                        "price": "499.00",
                        "oldPrice": "699.00",
                        "weight": [],
                        "RAM": [],
                        "SIZE": [
                            "M",
                            "L",
                            "XL"
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/rvurcwrojo/plutus-men-black-solid-polyester-casual-jacket-m-product-images-rvurcwrojo-0-202209240106.jpg",
                        "discount": "60",
                        "brand": "PLUTUS",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/rvurcwrojo/plutus-men-black-solid-polyester-casual-jacket-m-product-images-rvurcwrojo-0-202209240106.jpg",
                            "https://www.jiomart.com/images/product/original/rvurcwrojo/plutus-men-black-solid-polyester-casual-jacket-m-product-images-rvurcwrojo-1-202209240106.jpg",
                            "https://www.jiomart.com/images/product/original/rvurcwrojo/plutus-men-black-solid-polyester-casual-jacket-m-product-images-rvurcwrojo-2-202209240106.jpg",
                            "https://www.jiomart.com/images/product/original/rvurcwrojo/plutus-men-black-solid-polyester-casual-jacket-m-product-images-rvurcwrojo-3-202209240106.jpg",
                            "https://www.jiomart.com/images/product/original/rvurcwrojo/plutus-men-black-solid-polyester-casual-jacket-m-product-images-rvurcwrojo-4-202209240106.jpg"
                        ],
                        "rating": 5,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 46
                    },
                    {
                        "productName": "BULLMER Men Beige Cotton Blend Printed Single Sweatshirts",
                        "price": "699.00",
                        "oldPrice": "989.00",
                        "weight": [],
                        "RAM": [],
                        "SIZE": [
                            "M",
                            "L",
                            "XL"
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/rvqq9gohkt/bullmer-men-beige-cotton-blend-printed-single-sweatshirts-product-images-rvqq9gohkt-0-202210291839.jpg",
                        "discount": "60",
                        "brand": "BULLMER",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/rvqq9gohkt/bullmer-men-beige-cotton-blend-printed-single-sweatshirts-product-images-rvqq9gohkt-0-202210291839.jpg",
                            "https://www.jiomart.com/images/product/original/rvqq9gohkt/bullmer-men-beige-cotton-blend-printed-single-sweatshirts-product-images-rvqq9gohkt-1-202210291839.jpg",
                            "https://www.jiomart.com/images/product/original/rvqq9gohkt/bullmer-men-beige-cotton-blend-printed-single-sweatshirts-product-images-rvqq9gohkt-2-202210291839.jpg"
                        ],
                        "rating": 4.5,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 47
                    },
                    {
                        "productName": "Men Checked Slim Fit Shirt",
                        "price": "179.00",
                        "oldPrice": "489.00",
                        "weight": [],
                        "RAM": [],
                        "SIZE": [
                            "M",
                            "L",
                            "XL"
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/420395610_red/checked-slim-fit-shirt-model-420395610_red-0-202309052055.jpg",
                        "discount": "45",
                        "brand": "ROXTAR",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/420395610_red/checked-slim-fit-shirt-model-420395610_red-0-202309052055.jpg",
                            "https://www.jiomart.com/images/product/original/420395610_red/checked-slim-fit-shirt-model2-420395610_red-2-202309052055.jpg",
                            "https://www.jiomart.com/images/product/original/420395610_red/checked-slim-fit-shirt-model3-420395610_red-3-202309052055.jpg",
                            "https://www.jiomart.com/images/product/original/420395610_red/checked-slim-fit-shirt-model4-420395610_red-4-202309052055.jpg",
                            "https://www.jiomart.com/images/product/original/420395610_red/checked-slim-fit-shirt-model5-420395610_red-5-202309052055.jpg"
                        ],
                        "rating": 4.5,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 48
                    }
                ]
            },
            {
                "cat_name": "Women Western Wear",
                "products": [
                    {
                        "productName": "Rudraaksha Stylish Dress For women",
                        "price": "299.00",
                        "oldPrice": "389.00",
                        "weight": [],
                        "RAM": [],
                        "SIZE": [
                            "M",
                            "L",
                            "XL"
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/rvxsvl3imx/rudraaksha-stylish-dress-for-women-product-images-rvxsvl3imx-0-202210042034.jpg",
                        "discount": "65",
                        "brand": "Rudraaksha",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/rvxsvl3imx/rudraaksha-stylish-dress-for-women-product-images-rvxsvl3imx-0-202210042034.jpg",
                            "https://www.jiomart.com/images/product/original/rvxsvl3imx/rudraaksha-stylish-dress-for-women-product-images-rvxsvl3imx-1-202210042034.jpg",
                            "https://www.jiomart.com/images/product/original/rvxsvl3imx/rudraaksha-stylish-dress-for-women-product-images-rvxsvl3imx-2-202210042034.jpg",
                            "https://www.jiomart.com/images/product/original/rvxsvl3imx/rudraaksha-stylish-dress-for-women-product-images-rvxsvl3imx-3-202210042034.jpg"
                        ],
                        "rating": 4.5,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 49
                    },
                    {
                        "productName": "Fabflee Party Flared Sleeves Printed Women Yellow Top | Women Tops | Crepe Top | Tops For Women",
                        "price": "499.00",
                        "oldPrice": "589.00",
                        "weight": [],
                        "RAM": [],
                        "SIZE": [
                            "M",
                            "L",
                            "XL"
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/rvnipawgyz/fabflee-party-flared-sleeves-printed-women-yellow-top-women-tops-crepe-top-tops-for-women-product-images-rvnipawgyz-0-202309260654.jpg",
                        "discount": "65",
                        "brand": "Rudraaksha",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/rvnipawgyz/fabflee-party-flared-sleeves-printed-women-yellow-top-women-tops-crepe-top-tops-for-women-product-images-rvnipawgyz-0-202309260654.jpg",
                            "https://www.jiomart.com/images/product/original/rvnipawgyz/fabflee-party-flared-sleeves-printed-women-yellow-top-women-tops-crepe-top-tops-for-women-product-images-rvnipawgyz-1-202309260654.jpg",
                            "https://www.jiomart.com/images/product/original/rvnipawgyz/fabflee-party-flared-sleeves-printed-women-yellow-top-women-tops-crepe-top-tops-for-women-product-images-rvnipawgyz-2-202309260654.jpg",
                            "https://www.jiomart.com/images/product/original/rvnipawgyz/fabflee-party-flared-sleeves-printed-women-yellow-top-women-tops-crepe-top-tops-for-women-product-images-rvnipawgyz-3-202309260654.jpg",
                            "https://www.jiomart.com/images/product/original/rvnipawgyz/fabflee-party-flared-sleeves-printed-women-yellow-top-women-tops-crepe-top-tops-for-women-product-images-rvnipawgyz-4-202309260654.jpg"
                        ],
                        "rating": 4,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 50
                    },
                    {
                        "productName": "Shrug with Shawl Lapel",
                        "price": "699.00",
                        "oldPrice": "989.00",
                        "weight": [],
                        "RAM": [],
                        "SIZE": [
                            "M",
                            "L",
                            "XL"
                        ],
                        "catImg": "https://www.jiomart.com/images/product/original/441131609_grey/shrug-with-shawl-lapel-model-441131609_grey-0-202309271631.jpg",
                        "discount": "65",
                        "brand": "FIG",
                        "productImages": [
                            "https://www.jiomart.com/images/product/original/441131609_grey/shrug-with-shawl-lapel-model2-441131609_grey-2-202309271631.jpg",
                            "https://www.jiomart.com/images/product/original/441131609_grey/shrug-with-shawl-lapel-model3-441131609_grey-3-202309271631.jpg",
                            "https://www.jiomart.com/images/product/original/441131609_grey/shrug-with-shawl-lapel-model3-441131609_grey-3-202309271631.jpg",
                            "https://www.jiomart.com/images/product/original/441131609_grey/shrug-with-shawl-lapel-model4-441131609_grey-4-202309271631.jpg",
                            "https://www.jiomart.com/images/product/original/441131609_grey/shrug-with-shawl-lapel-model5-441131609_grey-5-202309271631.jpg"
                        ],
                        "rating": 5,
                        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
                        "id": 51
                    }
                ]
            }
        ]
    }
],
    "productReviews": [
    {
        "id": "a9cc",
        "review": "test",
        "userName": "test",
        "rating": "3",
        "productId": "2",
        "date": "6/17/2024, 8:12:19 PM"
    },
    {
        "id": "1755",
        "review": "again",
        "userName": "agsss",
        "rating": "2",
        "productId": "2",
        "date": "6/17/2024, 8:16:03 PM"
    },
    {
        "id": "136c",
        "review": "test",
        "userName": "sf",
        "rating": "3",
        "productId": "44",
        "date": "6/17/2024, 8:17:40 PM"
    }
],
    "cartItems": [
    {
        "id": 2,
        "productName": "Moong Dal 2 kg",
        "price": "246",
        "oldPrice": "320",
        "weight": [
            50,
            100,
            150,
            200,
            250,
            500
        ],
        "catImg": "https://www.jiomart.com/images/product/original/491432711/moong-dal-2-kg-product-images-o491432711-p491432711-0-202205191636.jpg",
        "discount": "16",
        "brand": "Private Label",
        "productImages": [
            "https://www.jiomart.com/images/product/original/491432711/moong-dal-2-kg-product-images-o491432711-p491432711-0-202205191636.jpg",
            "https://www.jiomart.com/images/product/original/491432711/moong-dal-2-kg-product-images-o491432711-p491432711-1-202205191636.jpg",
            "https://www.jiomart.com/images/product/original/491432711/moong-dal-2-kg-legal-images-o491432711-p491432711-3-202205191636.jpg"
        ],
        "rating": 4,
        "description": "Moong Dal is essentially packed with loads of nutrients that are extremely beneficial for your health. Moong contains almost every important element that your body might need. Buy Moong Dal online today.",
        "parentCatName": "groceries",
        "subCatName": "dals and pulses",
        "quantity": 1
    }
]
}
export default data;